import React from 'react';

import Card from 'bdvp-common/src/containers/Card';

import Carousel from './Carousel';
import Title from './Title';
import { Wrapper as SkeletonRowWrapper } from './Row';

const SkeletonRow = () => {

    return (
        <SkeletonRowWrapper>
            <Title isLoading={true}/>
            <Carousel isLoading={true} renderItem={() => <Card isLoading={true}/>}/>
        </SkeletonRowWrapper>
    );

};

export default SkeletonRow;
